const my_profile = {
  viewMyClubSeacretProfile: "Ver Perfil do Meu ClubeSeacret", // translated
  viewMoreDetails: "Ver mais detalhes", // translated
  unverifiedEmail: "E-mail não verificado", // translated
  verifiedEmail: "E-mail verificado", // translated
};

export default my_profile;
